import useClientState from '@/state/useClientState';

const WAIT_FOR_WERKLIJNEN_TIMEOUT_MS = 10_000;

/** Resolves once every werklijn is in the MWD werklijnenMap, or rejects after
 * WAIT_FOR_WERKLIJNEN_TIMEOUT_MS. Needed because selectWerklijn is a no-op until the werklijn
 * is loaded, and the map fills asynchronously (search results first go through coordinate
 * calculation inside a transition). Subscribes rather than polls, so it continues on the very
 * first update that completes the set.
 */
export default function waitForWerklijnenInMap(
  werklijnIds: string[],
  timeoutMs = WAIT_FOR_WERKLIJNEN_TIMEOUT_MS,
): Promise<void> {
  const isLoaded = () => {
    const { werklijnenMap } = useClientState.getState();
    return werklijnIds.every((werklijnId) => werklijnenMap.has(werklijnId));
  };

  if (isLoaded()) return Promise.resolve();

  return new Promise((resolve, reject) => {
    let unsubscribe: () => void = () => {};

    const timeout = globalThis.setTimeout(() => {
      unsubscribe();
      reject(new Error(`Werklijnen konden niet worden geopend: ${werklijnIds.join(', ')}`));
    }, timeoutMs);

    const finish = () => {
      globalThis.clearTimeout(timeout);
      unsubscribe();
      resolve();
    };

    unsubscribe = useClientState.subscribe(() => {
      if (isLoaded()) finish();
    });

    // The map may have been filled between the initial check and the subscription being set up.
    if (isLoaded()) finish();
  });
}
